import PropTypes from 'prop-types';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import countSuffix from '@/helpers/countSuffix';
import { IndexerKpiCard } from '@/app/Indexer/components/IndexerKpiCard';
import TextLoading from '@/app/common/components/skeleton/TextLoading';
import './backlinkKpiCards.css';

const DomainCount = ({ count, loading = false }: Record<string, any>) => {
  return (
    <IndexerKpiCard tone="success" imageIndex={1} className="h-100">
      <div className="overview-kpi-value position-relative">
        {loading ? (
          <>
            <span className="invisible" aria-hidden>
              0
            </span>
            <span
              className="position-absolute top-50 start-0 translate-middle-y d-block"
              style={{ width: '45%' }}
            >
              <TextLoading height={14} />
            </span>
          </>
        ) : (
          <span>{countSuffix(Number(count ?? 0))}</span>
        )}
      </div>
      <div className="text-secondary small d-inline-flex align-items-center gap-1">
        <span>تعداد دامنه</span>
        <HelpTooltip html="تعداد دامنه‌های یکتایی که به آدرس یا دامنه انتخاب‌شده لینک داده‌اند." />
      </div>
    </IndexerKpiCard>
  );
};

DomainCount.propTypes = {
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  loading: PropTypes.bool
};

export default DomainCount;
